<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M849.8 148.9c-6.8-9-14.3-17.7-22.2-25.9-51.1-52.7-119-81.7-191.2-81.7H319.7c-72.2 0-140.1 29-191.2 81.7S49.3 245.7 49.3 320.1v359.2c0 74.4 28.1 144.4 79.2 197.1 8.5 8.7 17.4 16.8 26.7 24.2 47 37.3 104.3 57.5 164.5 57.5h189c15.8 0 28.8-12.9 28.8-28.8 0-15.8-12.9-28.8-28.8-28.8h-189c-118.3 0-214.6-99.3-214.6-221.3V320.1c0-122 96.3-221.3 214.6-221.3h316.6c110.9 0 202.4 87.3 213.4 198.7.7 7.4 1.1 15 1.1 22.6v268c3.4 11.9 14.4 20.6 27.4 20.6 15.7 0 28.5-12.8 28.5-28.5V320.1c0-62.8-20-122.4-56.9-171.2z" data-follow-fill="currentColor" :fill="_fill" />
      <path
        d="M537.5 929.4c0 15.8-12.9 28.8-28.8 28.8h-189c-60.2 0-117.5-20.2-164.5-57.5h353.5c15.9-.1 28.8 12.8 28.8 28.7zm369.2-609.3v260.1c0 15.7-12.8 28.5-28.5 28.5-13 0-24-8.7-27.4-20.6-.7-2.5-1.1-5.1-1.1-7.9V148.9c37 48.8 57 108.4 57 171.2zm-605.5 31.8c23.4-39.5 38-53.2 46.1-57.8 8.2-4.6 26.5-10 67.4-10 11.7 0 18.1.4 21.6.7.3 2.1.5 5.5.5 10.6v321.5c0 2.5-.7 3.2-2 3.9-1.1.7-5.8 2.9-20.1 2.9h-45.3v37h217.9v-36.9H542c-8.2 0-14.6-1.1-19.3-3.4-2.8-1.4-2.8-2.3-2.8-3.3V297.8c0-6.3.3-10.3.6-12.7 4.7-.4 14-.8 32.7-.8 42.2 0 57.1 6.4 62.2 10.3 6.9 5.2 20.1 19.4 43.9 57.7l3.9 6.3 40.4-4.9L666.3 245H294.4l-42.1 108.9 45 4.6 3.9-6.6zm508.4 539.4v-.3c0-96.3 45.6-185.6 120.1-235.3 13-8.7 30-4.1 37.8 10.4 7.9 14.4 3.7 33.2-9.4 41.9-32.7 21.8-58.9 53.9-75.1 92.2 34-4.2 66.9 15.3 82.6 49 15.7 33.7 11 74.6-11.8 102.9-22.8 28.3-59 38.1-91 24.6s-53.2-47.5-53.2-85.4zm-220.5 0v-.3c0-96.3 45.6-185.6 120.1-235.3 13-8.7 30-4.1 37.8 10.4 7.9 14.4 3.7 33.2-9.4 41.9-32.7 21.8-58.9 53.9-75.1 92.2 34-4.2 66.9 15.3 82.6 49 15.7 33.7 11 74.6-11.8 102.9-22.8 28.3-59 38.1-91 24.6-31.9-13.5-53.1-47.5-53.2-85.4z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
